export const INVENTORY_PAGE_CUSTOM_EVENTS = {
  OPEN_LEAD_FORM: 'OPEN_LEAD_FORM',
  OPEN_SIGN_IN_TED_MODAL: 'OPEN_SIGN_IN_TED_MODAL',
  DIGITAL_RETAIL_ENTRY_OPEN_TED: 'DIGITAL_RETAIL_ENTRY_OPEN_TED',
};
